import { BaseBlock } from "./BaseBlock";
import { ActionButtonElement } from "../elements/ActionButtonElement";

import type { AccountActions }
    from "../screens/components/AccountActions";

import type {
    AppState
} from "../app/state/AppState";

type Subscription =
    NonNullable<
        AppState["accountData"]
    >["products"][number]["subscriptions"][number];

export class SubscriptionBlock
    extends BaseBlock {

    private readonly subscription: Subscription;
    private readonly actions: AccountActions;

    private root!: HTMLElement;

    constructor(
        subscription: Subscription,
        actions: AccountActions
    ) {

        super();

        this.subscription = subscription;
        this.actions = actions;

    }

    public override mount(): void {

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =========================

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        root.className =
            "account-sub-block";

        const title =
            document.createElement("h4");

        title.textContent =
            this.subscription.renewal_active
                ? "Поточна підписка"
                : "Попередня підписка";

        root.appendChild(
            title
        );

        const stickerTitle =
            document.createElement("p");

        stickerTitle.innerHTML =
            `<b>${this.subscription.sticker_title}</b>`;

        root.appendChild(
            stickerTitle
        );

        root.insertAdjacentHTML(
            "beforeend",
            `
                <p>
                   Кількість кроків:
                    <b>${this.subscription.cycle_krok_limit}</b>
                    на
                    <b>${this.subscription.cycle_days}</b>
                    дн.
                </p>

                <p>
                    Залишилось днів:
                    <b>${this.subscription.remaining_days}</b>
                </p>
            `
        );

        if (this.subscription.renewal_active) {

            root.insertAdjacentHTML(
                "beforeend",
                `
                    <p>
                        Автопродовження увімкнено
                    </p>

                    <p>
                        Наступна оплата:
                        <b>${this.subscription.next_payment_date}</b>
                    </p>
                `
            );

            if (this.subscription.subscription_id) {

                this.appendButton(

                    root,

                    "Скасувати автопродовження",

                    "cancel-subscription-btn",

                    () => {

                        this.actions.confirmCancelSubscription(

                            this.subscription.subscription_id

                        );

                    }

                );

            }

        } else {

            root.insertAdjacentHTML(
                "beforeend",
                `
                    <p>
                        Автопродовження вимкнено
                    </p>
                `
            );

        }

        return root;

    }

    private appendButton(
        root: HTMLElement,
        text: string,
        className: string,
        clicked: () => void
    ): void {

        const actions =
            document.createElement("div");

        actions.className =
            "account-actions";

        const button =
            new ActionButtonElement({

                text,

                className,

                clicked

            });

        button.mount();

        actions.appendChild(
            button.getRoot()
        );

        root.appendChild(
            actions
        );

    }

}